import {motion, AnimatePresence } from 'framer-motion'
import {useState} from 'react';
import {drawingImgVariant} from '../Variants/drawingVariants'
import DrawingModal from './DrawingModal';
import Overlay from './Overlay';

const DrawingCard = ({image}) => {
    const [open, setOpen] = useState(false);
    const openModal = () => {
        setOpen(true);
    }

    const closeModal = () => {
        setOpen(false);
    }

    return(
        <>
        <motion.div 
        className="drawings-card" 
        onClick={openModal}>
            <motion.div className="card-container"
            layoutId={image.title}
            >
                <motion.div className='drawing-image' 
                variants={drawingImgVariant}
                initial="initial"
                animate="animate"
                layoutId={image.id}>
                    <motion.img 
                    style={{borderRadius: "20px"}}
                    layoutId={image.url[0]}
                    src={image.img} 
                    alt="" 
                    ></motion.img>
                </motion.div>
            </motion.div>
        </motion.div>
        
        <AnimatePresence>
            {open && (
                <Overlay key={image} closeModal={closeModal}>
                    <DrawingModal image={image} closeModal={closeModal}/>
                </Overlay>
            )}
        </AnimatePresence>
        </>
    )
}

export default DrawingCard;